<template>
  <div id="permission_create" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading">
    </div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <span class="page-title" id="grantPermissionHeader">Grant Permission</span>
          <a href="javascript:void(0)" class="btn btn-secondary pull-right" v-on:click="exportReports()">
            <i class="fp-export"></i> Export
          </a>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content grant-permission">
            <section class="internal-container border-top-table-fl">
              <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="Roleform">
                <div class="form-row">
                  <div class="col-md-6 form-group">
                    <label class="control-label require role-name-label" for="role_name">Role Name: </label>
                    <v-select id="role_name" name="role_name"
                              placeholder="Select Role Name" v-model="role_name"
                              :options="roleArr" label="text"></v-select>
                    <div class="field-error">{{ role_name_msg }}</div>
                  </div>
                </div>
                <div class="mark-all mt-4 mb-2">
                  <input type="checkbox" @click="selectAll($event)" v-model="allSelected">
                  <label id="markCheckBox" class="checkbox-custom">Mark ALL</label>
                </div>
                <div class="form-row row-cols-md-4 row-cols-1 permission-lists pl-3 pr-3">
                  <template v-for="(permission,key) in allPermissions">
                    <div v-bind:key="'permission'+key" class="col form-group no-translate">
                      <h2 class="card-inside-title">
                        <div class="custom-checkbox">
                          <label class="checkbox-custom">{{ permission.module_name }}
                            <input type="checkbox" v-bind:id="'module_id_'+permission.id"
                                   @change="selectByModule(permission.id,$event)" :value="permission.id"
                                   v-model="enquiries">
                            <span class="checkmark"></span>
                          </label>
                        </div>
                      </h2>
                      <div class="permission-inside-list">
                        <template v-for="(permissionData,permissionKey) in allPermissions[key]['module_permissions']">
                          <div class="custom-checkbox" :key="permissionKey">
                            <label class="checkbox-custom">
                              <input type="checkbox" v-bind:value="permissionData.id"
                                     v-model="roleData.checkedPermissions" name="checkedPermissions[]"
                                     @change="selectRolePermission(permissionData.id,$event,permission.id,permissionData.permission_name)"
                                     v-bind:id="'pId_' + permission.id +'_'+permissionData.permission_name">
                              {{ permissionData.name }}
                              <span class="checkmark"></span>
                            </label>
                          </div>
                        </template>
                      </div>
                    </div>
                    <hr v-bind:key="key+'clear'" v-if="(key + 1) % 4 === 0" class="clearfix light-hr"/>
                  </template>
                </div>
                <div class="form-group" v-show="successAlert">
                  <div class="alert alert-success" id="alertSuccess">
                    <button type="button" class="close" aria-label="Close" @click="alertClose"><span aria-hidden="true">&times;</span>
                    </button>
                    <strong>Permission Set For This Role Successfully.</strong>
                  </div>
                </div>
                <div class="form-group">
                  <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span
                      aria-hidden="true">&times;</span></button>
                    <strong id="errorMsg" class="field-error"></strong>
                  </div>
                </div>
                <div class="btn-groups">
                  <button type="submit" id="createPermissionBtn" class="btn btn-primary"
                          v-on:click.prevent="GrantPermission">
                    <i class="fp-save"> </i> Save
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>
              Oops!</h1>
            <h2>
              403 </h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>

  </div>
</template>
<script>
import Vue from "vue";
import EventBus from "./event-bus";

import {commonMixins} from '../mixins/commonMixins'


var moduleIdArr = [];
var permissionNameArr = [];


export default {
  name: "ModuleCreate",

  metaInfo() {
    return {title: "Grant Permission | " + process.env.COPYRIGHT_NAME}
  },
  mixins: [commonMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    role_name: null,
    enquiries: [],
    roleArr: [],
    allPermissions: [],
    roleData: {
      name: '',
      checkedPermissions: []
    },
    modulePermissions: [],
    allSelected: false,
    isModuleChecked: false,
    role_name_msg: "",
    isPermissionChecked: false,
    loading: false,
    successAlert: false
  }),
  watch: {
    role_name(role_name) {

      var self = this;

      //uncheck Check all box
      self.allSelected = false;
      self.enquiries = [];
      $("#markCheckBox").text('Mark ALL');
      //uncheck all module checkbox
      self.modulePermissions = [];
      self.isModuleChecked = false;

      if (role_name != null) {
        $.ajax({
          url: process.env.ROOT_API + "/get-assignedpermission",
          type: "GET",
          headers: this.ajxHeaders,
          crossDomain: true,
          dataType: "json",
          data: {
            id: role_name.value,
          },
          success: function (data) {
            console.log(data.assigned_permission);

            if (data.message == "success") {

              self.roleData.checkedPermissions = data.assigned_permission;

              // setTimeout(function () {

              //     var permission_name = data.assigned_permission_name;
              //     var module_id = data.assigned_permission_moduleID;

              //     // alert(module_id);

              //     self.moduleData(module_id);
              //     self.defaultPermission(permission_name);

              // }, 1000);
            }

          },
          error: function (jqXHR, exception) {
            self.Registerbtn = "Register";
            self.generateStatusCodeMessage(jqXHR, true, 'permission-get-by-role')
          }
        });
      } else {
        self.roleData.checkedPermissions = [];
      }
    },

    //check permission change
    permissions: function (permissions) {

      var self = this;
      if (permissions.length > 0) {
        for (var i = 0; i < permissions.length; i++) {
          if (permissions[i].name == 'grant_permission') {
            self.cantAccessPage = true;
          }
        }
      }

    }
  },
  created: function () {

  },
  mounted: function () {
    var self = this;

    var path = window.location.pathname;
    var segments = path.split("/");

    if (segments[3]) {
      $("#createPermissionBtn").text("Update");
      $("#grantPermissionHeader").text("Edit Permission");

    }
    self.getPermissions();
    self.loadRole();
    self.loadPermission();
  },
  methods: {

    moduleData(module_id) {

      moduleIdArr = $.unique(module_id);
      var itemtoRemove = 4;
      moduleIdArr.splice($.inArray(itemtoRemove, moduleIdArr), 1);

      alert(moduleIdArr.length);
    },

    defaultPermission(permission_name) {

      for (var i = 0; i < permission_name.length; i++) {

        var name = permission_name[i].split("_");
        if (name[0] == 'list') {

          permissionNameArr.push(permission_name[i])
          // var listPermission = '#pId_' + moduleIdArr[i] + "_list_" + name[];
          // $(listPermission).prop("disabled", true);
        }
      }
      alert(permissionNameArr.length);

      for (var i = 0; i < permissionNameArr.length; i++) {

        var listPermission = '#pId_' + moduleIdArr[i] + "_" + permissionNameArr[i];
        $(listPermission).prop("disabled", true);
      }

      moduleIdArr = [];
      permissionNameArr = [];
    },

    BackPermissionList() {

      var self = this;
      //   self.$router.push("/permissions/list");
    },

    selectAll: function (ev) {

      var self = this;
      var selected = [];

      if (ev.target.checked == true) {
        self.allSelected = false;
      } else {
        self.allSelected = true;
      }
      if (!self.allSelected) {

        self.allPermissions.forEach(function (permissions) {
          console.log(permissions.id);
          self.modulePermissions.push(permissions.id);
          console.log(self.modulePermissions);
          console.log("main permisssion", permissions.module_permissions.length);
          for (var i = 0; i < permissions.module_permissions.length; i++) {
            console.log("permission", permissions.module_permissions[i]['name']);
            selected.push(permissions.module_permissions[i]['id']);
          }

        });
        $("#markCheckBox").text('UnMark ALL');
        self.enquiries = self.modulePermissions;
        self.isModuleChecked = true;
        self.allSelected = true;
      } else {
        $("#markCheckBox").text('Mark ALL');
        self.allSelected = false;
        self.enquiries = [];
        self.modulePermissions = [];
        self.isModuleChecked = false;
        console.log(self.enquiries);
        console.log(self.modulePermissions);
      }
      self.roleData.checkedPermissions = selected;
      console.log(selected);
    },

    alertClose(event) {
      // Prevent the default action
      event.preventDefault();
      this.successAlert = false;
    },

    GrantPermission: function () {

      var self = this;
      // self.role_name.value;
      self.role_name_msg = "";

      if (self.role_name == null || !self.role_name.value) {
        self.role_name_msg = "Role Name Required.";
      } else {
        self.role_name_msg = "";
      }

      if (self.role_name_msg == "") {

        self.loading = true;
        var fields = $('#Roleform').serializeArray();
        // field.push({name : 'permissions',value : self.roleData.checkedPermissions});
        fields.push({name: 'role', value: self.role_name.value});

        $("#addRoleBtn").val("Saving...");
        $("#addRoleBtn").prop("disabled", true);
        $("#CancelRole").prop("disabled", true);

        $.ajax({
          url: process.env.ROOT_API + "/grant_permission/create",
          type: "POST",
          crossDomain: true,
          headers: this.ajxHeaders,
          dataType: "json",
          data: fields,
          success: function (data) {
            self.loading = false;
            if (self.permission_id != undefined) {
              self.Registerpermissionbtn = "UPDATE";
            } else {
              self.Registerpermissionbtn = "Add";
            }
            $("#addRoleBtn").val("Save");
            $("#addRoleBtn").prop("disabled", false);
            $("#CancelRole").prop("disabled", false);

            if (data.status == "success") {

              self.successAlert = true;

              setTimeout(function () {
                self.successAlert = false;
              }, 10000);
              console.log($(".error_style").length);
              self.msgClass = "success";
              document.getElementById("registerRole");
              $("#registerPermission").trigger("reset");

            } else {
              if (data.content.length > 0) {
                var err = "";
                for (var i = 0; i < data.content.length; i++) {
                  err += data.content[i] + "<br>";
                }
                $("#errorMsg").html(err);
                $(".alert-warning").toggleClass("show");
                setTimeout(function () {
                  $(".alert-warning").removeClass("show");
                  $(".alert-warning").addClass("hide");
                }, 10000);
              }
            }
          },
          error: function (jqXHR, exception) {
            self.loading = false;
            $("#addRoleBtn").val("Save");
            $("#addRoleBtn").prop("disabled", false);
            $("#CancelRole").prop("disabled", false);

            self.errorMsg = jqXHR.responseJSON.message;

            self.generateStatusCodeMessage(jqXHR, true, 'permission-create')
          }
        });
      } else {
        self.errorValidationFocus();
      }
      // self.$validator.validate().then(result => {
      //     if (result) {


      //     }
      // });

    },

    loadPermission() {

      var self = this;
      self.loading = true;

      $.ajax({
        url: process.env.ROOT_API + "/get-permissions",
        type: "GET",
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          // console.log(data);
          if (data.status == "success") {
            self.allPermissions = data.content;
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.Registerbtn = "Register";
          self.generateStatusCodeMessage(jqXHR, true, 'permission-get')
        }
      });
    },

    loadRole() {

      var self = this;

      $.ajax({
        url: process.env.ROOT_API + "/get-roles",
        type: "GET",
        headers: this.ajxHeaders,
        crossDomain: true,
        success: function (data) {
          // console.log(data.content);
          if (data.status == "success") {

            self.roleArr = data.content;
          }

        },
        error: function (jqXHR, exception) {
          self.Registerbtn = "Register";
          self.generateStatusCodeMessage(jqXHR, true, 'permission-get-role')
        }
      });

    },

    selectByModule: function (module_id, $event) {

      var self = this;
      console.log(module_id);
      self.isModuleChecked = $event.target.checked;

      if (self.allSelected) {
        self.allSelected = false;
        $("#markCheckBox").text('Mark ALL');
      }

      if (self.isModuleChecked == true) {
        //to check if module_id of checked Module Name already exists in array modulePermissions
        if (jQuery.inArray(module_id, self.modulePermissions) == -1) {

          self.modulePermissions.push(module_id);
          console.log("Push Module_Id:: " + module_id);

        }
        self.allPermissions.forEach(function (permissions) {
          for (var i = 0; i < permissions.module_permissions.length; i++) {
            // console.log("permission_module_id",permissions.module_permissions[i]['module_id']);
            if (permissions.module_permissions[i]['module_id'] == module_id) {

              console.log(permissions.module_permissions[i]['module_id'] + " " + permissions.module_permissions[i]['id']);

              var permission_id = permissions.module_permissions[i]['id'];

              if (self.isModuleChecked == true) {
                //to check if permission_id of checked Permission already exists in array modulePermissions
                if (jQuery.inArray(permission_id, self.roleData.checkedPermissions) == -1) {
                  console.log("Push:: " + permission_id);
                  self.roleData.checkedPermissions.push(permission_id);

                }

              }

            }
          }
        });

      } else {

        if (jQuery.inArray(module_id, self.modulePermissions) != -1) {

          var idx = self.modulePermissions.indexOf(module_id);
          if (idx !== -1) {
            self.modulePermissions.splice(idx, 1);
            console.log("Pop Module_Id:: " + module_id);
          }

        }

        self.allPermissions.forEach(function (permissions) {
          for (var i = 0; i < permissions.module_permissions.length; i++) {
            // console.log("permission_module_id",permissions.module_permissions[i]['module_id']);
            if (permissions.module_permissions[i]['module_id'] == module_id) {

              console.log(permissions.module_permissions[i]['module_id'] + " " + permissions.module_permissions[i]['id']);

              var permission_id = permissions.module_permissions[i]['id'];

              if (jQuery.inArray(permission_id, self.roleData.checkedPermissions) != -1) {

                var idx = self.roleData.checkedPermissions.indexOf(permissions.module_permissions[i]['id']);
                if (idx !== -1) {

                  self.roleData.checkedPermissions.splice(idx, 1);
                  console.log("Pop:: " + permission_id);

                }
              }

            }
          }
        });
      }
      self.enquiries = self.modulePermissions;
    },

    selectRolePermission: function (permission_id, $event, module_id, permission_name) {

      var self = this;

      var checkboxValue = $event.target.checked;
      console.log(checkboxValue);

      var name = permission_name.split("_");

      var id = $event.target.id;
      console.log(id);

      if (checkboxValue == true) {

        //condition to check whether checkbox containing add,update or delete permissions is checked
        if (name[0] == 'add' || name[0] == 'update' || name[0] == 'delete') {

          var permissionId = '#pId_' + module_id + '_list';
          var listPermission = '#pId_' + module_id + '_list_' + name[1];
          // $(listPermission).prop("disabled", true);


          //to generate permission id(permissionId) and skip the value add or update or delete
          for (var i = 0; i < name.length; i++) {
            if (i != 0) {
              // to append the module name to varia
              permissionId += ('_' + name[i]);
            }
          }
          console.log("Name : " + name + ", PID : " + listPermission);

          var permId = $(permissionId).val();

          if (jQuery.inArray(parseInt(permId), self.roleData.checkedPermissions) == -1) {

            self.roleData.checkedPermissions.push(parseInt(permId));
            console.log("push :: " + permId + ' ' + parseInt(permId));
          }
          console.log(self.roleData.checkedPermissions);
        }

      } /*else{

            var addPermission = '#pId_' + module_id + '_add_' + name[1];
            var deletePermission = '#pId_' + module_id + '_delete_' + name[1];
            var updatePermission = '#pId_' + module_id + '_update_' + name[1];

            var addUserPermission = '#pId_' + module_id + '_add_user';
            var updateUserPermission = '#pId_' + module_id + '_update_user';

            var add = $(addPermission).prop('checked');
            var deleteValue = $(deletePermission).prop('checked');
            var update = $(updatePermission).prop('checked');

            var addUser = $(addUserPermission).prop('checked');
            var updateUser = $(updateUserPermission).prop('checked');

            if (add == false && deleteValue == false && update == false){

                var listPermission = '#pId_' + module_id + '_list_' + name[1];
                $(listPermission).prop("disabled", false);
            }

            if (addUser == false && updateUser == false){

                var listPermission = '#pId_' + module_id + '_list_' + name[1];
                $(listPermission).prop("disabled", false);
            }
        }*/

      if (self.allSelected) {

        self.allSelected = false;
        $("#markCheckBox").text('Mark ALL');
      }
    },
    exportReports: function () {
      var self = this;
      self.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/roles_permission/export",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          if (data.code == "201") {
            alert(data.message);
          } else {

            var excel = data.content.web;
            var save = document.createElement("a");
            save.href = excel;
            save.download = data.content.web;
            save.target = "_blank";

            document.body.appendChild(save);
            save.click();
            document.body.removeChild(save);
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.errorMsg = jqXHR.responseJSON.message;

          self.generateStatusCodeMessage(jqXHR, true, 'permission-create')
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/GrantPermission.vue